import MobileNav from "@/components/mobileNav";
import AppSidebar from "@/components/sidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useGetRecentTransactions, useGetUser } from "@/hooks/use-queries";
import { AuthProvider } from "@/lib/AuthProvider";
import { useCardsStore, useUser } from "@/zustand/store";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { CardCreationNoticeModal } from "@/components/card-unavailable";
import SideSheet from "@/components/sheets";
import Modal from "@/components/modals/index";
import { AnimatePresence } from "framer-motion";
import LogoLoader from "@/components/animated-logo";
import { motion } from "framer-motion";
import { ErrorBoundary } from "react-error-boundary";
import * as Sentry from "@sentry/react";
import ErrorFallback from "@/components/error-fallback";
import Throbber from "@/components/throbber";

const DashboardLayout = () => {
  const { data: user, isLoading: loading } = useGetUser();
  const { isLoading: transactionsIsLoading } = useGetRecentTransactions();
  const { isCardUnavailableOpen } = useCardsStore((state) => state);

  useEffect(() => {
    useUser.setState({ user: user });
  }, [user]);

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div className="">
        <AuthProvider>
          <AnimatePresence>
            {loading || transactionsIsLoading ? (
              <motion.div
                key="loader"
                initial={{ opacity: 1 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                className="fixed inset-0 z-[9999] flex items-center justify-center bg-white"
              >
                <Throbber />
              </motion.div>
            ) : (
              <SidebarProvider>
                <AppSidebar />
                <MobileNav />
                <main className="relative min-h-dvh w-full bg-[#151515] pb-20 lg:pb-6">
                  {<Outlet />}
                </main>
                {/* <ChatSupport /> */}
              </SidebarProvider>
            )}
          </AnimatePresence>
          <SideSheet />
          <Modal />
          {isCardUnavailableOpen && <CardCreationNoticeModal />}
        </AuthProvider>
      </div>
    </ErrorBoundary>
  );
};

export default DashboardLayout;
